import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import { ButtonText, Headline3, QuoteText, Subtitle1, Subtitle2 } from 'stories/elements/Typography/Text'
import { AnalyticsEventTutoringLandingPageTalkToSalesButtonClick } from 'lib/constants/AnalyticsEventType'
import { trackEvent } from 'lib/tracking/analytics-service'
import { UserQuoteSlice } from 'interfaces/GeneratedLandingPage'
import QuoteIcon from 'assets/icons/user_quote.svg'
import DynamicButton from './DynamicButton'

const Container = styled.div<{ backgroundColor: string }>`
    width: 100%;
    height: 100vh;
    background-color: ${({ backgroundColor }) => backgroundColor ?? theme.colors.accentBlue};
    overflow: hidden;
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
    place-content: center;
    align-items: center;
    @media (max-width: 750px) {
        height: 800px;
        grid-template-columns: 1fr;
    }
`

const TextWrapper = styled.div`
    display: grid;
    grid-gap: 15px;
    padding-left: 25%;
    @media (max-width: 1050px) {
        padding-left: 15%;
    }
    h4 {
        width: 80%;
    }
    @media (max-width: 750px) {
        height: 400px;
        padding: 0 10%;
        place-content: center;
        div,
        h5,
        h4 {
            width: 100%;
            text-align: center;
        }
    }
`

const TestimonialContainer = styled.div<{ backgroundColor: string }>`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 30px 20% 0 20%;
    justify-content: center;
    align-items: center;
    position: relative;
    gap: 20px;
    background-color: ${({ backgroundColor }) => backgroundColor ?? theme.colors.accentBlue};
    @media (max-width: 750px) {
        height: 400px;
        padding: 0 10%;
        place-content: center;
        p {
            width: 100%;
            text-align: center;
        }
    }
`

interface Props {
    data: UserQuoteSlice['primary']
}

const UserQuote = ({ data }: Props) => {
    const handleTalkToSalesButtonClick = () => {
        trackEvent(AnalyticsEventTutoringLandingPageTalkToSalesButtonClick, {
            value: 'with_discount',
        })
    }
    return (
        <Container backgroundColor={data.background_color ?? theme.colors.accentBlue}>
            <TextWrapper>
                <Subtitle1 color={theme.colors.white}>{data.title}</Subtitle1>
                <Headline3 color={theme.colors.white} marginBottom={50}>
                    {data.subtitle}
                </Headline3>

                <DynamicButton
                    onClick={handleTalkToSalesButtonClick}
                    href={data?.button_link}
                    target="_blank"
                    borderRadius={theme.borderRadius.normal}
                    height={60}
                    width={250}
                    type="white"
                >
                    <ButtonText color={theme.colors.accentBlue}>{data.button_text}</ButtonText>
                </DynamicButton>
            </TextWrapper>
            <TestimonialContainer backgroundColor={data.background_color ?? theme.colors.accentBlue}>
                <QuoteIcon />
                <QuoteText color={theme.colors.white} marginBottom={10} textAlign="center">
                    {data.user_quote}
                </QuoteText>
                <Subtitle2 color={theme.colors.white} textAlign="center" marginBottom={10}>
                    {data.user_title}
                </Subtitle2>
            </TestimonialContainer>
        </Container>
    )
}

export default UserQuote
